var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"product-customisation-modal","width":"1200","height":"auto","scrollable":"","adaptive":""},on:{"before-open":_vm.handleModalBeforeOpen,"opened":_vm.handleModalOpened}},[_c('ProductVariations',{attrs:{"product":_vm.product,"show-preview":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }